<template lang='pug' src='./custom-office-family.pug'></template>

<script>
export default {
  props: ['props'],
  data () {
    return {
      titleActive: false,
      active: false
    }
  }
}
</script>



// WEBPACK FOOTER //
// custom-office-family.vue?7ded296f